import { map } from 'lodash';
import Actions from '../actions/actions';
import GoogleSheetsCRUDActions from '../actions/GoogleSheetsCRUDActions';
import {
  GoogleAccount,
  GoogleSheet,
  SheetColumns,
  SheetsById,
  SpreadsheetsById,
} from '../interfaces/googleSheet';
import { setBusy, setUnBusy } from './common/commonReducers';

type ActionType = {
  type: string;
  accounts: GoogleAccount[];
  accountsId: number[];
  spreadsheets: SpreadsheetsById;
  sheets: SheetsById;
  columns: SheetColumns;
};

const initialState: GoogleSheet = {
  busy: false,
  accounts: [],
  accountsId: [],
  spreadsheetsById: null,
  sheetsById: null,
  columns: null,
};

export const googleSheets = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case GoogleSheetsCRUDActions.busyAction:
      return setBusy(state);
    case GoogleSheetsCRUDActions.retrieveAccounts: {
      return {
        ...state,
        accounts: action.accounts,
        accountsId: map(action.accounts, 'id'),
        busy: false,
      };
    }
    case GoogleSheetsCRUDActions.retrieveSpreadsheets: {
      return {
        ...state,
        spreadsheetsById: action.spreadsheets,
        busy: false,
      };
    }
    case GoogleSheetsCRUDActions.retrieveSheets: {
      return {
        ...state,
        sheetsById: action.sheets,
        busy: false,
      };
    }
    case GoogleSheetsCRUDActions.retrieveColumns: {
      return {
        ...state,
        columns: action.columns,
        busy: false,
      };
    }
    case GoogleSheetsCRUDActions.revokeAccess: {
      return {
        ...state,
        busy: false,
      };
    }
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
};
